module.exports = __webpack_public_path__ + "static/img/Frame.9152f385.png";